/* eslint-disable */

let $ = window.jQuery;

$(document).ready(function () {    
    //caches a jQuery object containing the header element
    let $toggle = $('.c-header__toggle');
    let $navigation = $('.c-navigation__main');
    let $header = $('.c-site-header');
    
    $toggle.on('click', function(event){
        $toggle.toggleClass('active');
        $navigation.stop().slideToggle(500);
        $header.toggleClass('c-site-header--open');
        event.preventDefault();
    });
});

/* eslint-enable */
